export const productKey = {
  StrykeDeprecatedHoneyUsdcVault: 'stryke-deprecated-honey-usdc-vault',
  StrykeHoneyUsdcVault: 'stryke-honey-usdc-vault',
  StrykeWberaHoneyVault: 'stryke-wbera-honey-vault',
} as const

export type ProductKey = typeof productKey[keyof typeof productKey]
